import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker (vite-plugin-pwa). virtual:pwa-register handles SW
// registration in production; in dev it's a no-op.
import { registerSW } from "virtual:pwa-register";
registerSW({ immediate: true });
